/**
 * What a Camera2D frames, after `camera_2d.cpp::get_camera_transform()`: pure math
 * from its parsed properties and world position to the view centre in Godot canvas
 * pixels and the magnification. DRAG_CENTER centres the view on the camera, and
 * FIXED_TOP_LEFT puts the camera at its corner.
 */
import { isZeroApprox } from '../../../godot/math/math.js';
import { Camera2DAnchorMode } from '../../../godot/scene/camera2d.js';
export function camera2DView(props, worldPosition, viewportSize) {
    // `set_zoom` refuses the whole write when either component is zero-approx
    // (camera_2d.cpp:104), so (1, 1) stays on both axes: `Vector2(0, 2)` frames at
    // (1, 1), as the validator reads it. The rect is `screen_size * zoom_scale`, per
    // axis (camera_2d.cpp:107, :163).
    const refused = isZeroApprox(props.zoom.x) || isZeroApprox(props.zoom.y);
    const zoom = refused ? 1 : props.zoom.x;
    const zoomY = refused ? 1 : props.zoom.y;
    const viewWidth = viewportSize.x / zoom;
    const viewHeight = viewportSize.y / zoomY;
    // Godot clamps the view rect before it adds `offset`, so work in top-left space
    // and convert back. The offset camera can go past the limits.
    let left = worldPosition.x;
    let top = worldPosition.y;
    if (props.anchor_mode !== Camera2DAnchorMode.FIXED_TOP_LEFT) {
        left -= viewWidth / 2;
        top -= viewHeight / 2;
    }
    if (props.limitEnabled !== false) {
        left = clampToLimits(left, viewWidth, props.limitLeft, props.limitRight);
        top = clampToLimits(top, viewHeight, props.limitTop, props.limitBottom);
    }
    return {
        center: {
            x: left + viewWidth / 2 + props.offset.x,
            y: top + viewHeight / 2 + props.offset.y,
        },
        size: { x: viewWidth, y: viewHeight },
        zoom,
    };
}
/**
 * One axis of Godot's limit clamp, in the engine's branch order. A view wider than
 * the span between the limits centres in the span, pinned to neither edge.
 */
function clampToLimits(position, extent, near, far) {
    if (near > far - extent)
        return (near + far - extent) / 2;
    if (position < near)
        return near;
    if (position + extent > far)
        return far - extent;
    return position;
}
//# sourceMappingURL=cameraView.js.map